/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from '@servicetitan/application-data/common-interfaces';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IWorkspaceApi {
    getComponents(componentIds: string[] | null | undefined, cancelToken?: CancelToken): AxiosPromise<UserWorkspaceComponentApiModel[]>;
    saveComponentState(model: ComponentStateSaveApiModel, cancelToken?: CancelToken): AxiosPromise<void>;
    /**
     * @return or

    or

    or

    or

    or

    or

    or

    or

    or

    or

    or

    or
     */
    componentTypes(cancelToken?: CancelToken): AxiosPromise<any>;
}

export const BASE_URL_TOKEN_WorkspaceApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class WorkspaceApi implements IWorkspaceApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_WorkspaceApi) @optional() private readonly baseUrl = "") {
    }

    getComponents(componentIds: string[] | null | undefined, cancelToken?: CancelToken): AxiosPromise<UserWorkspaceComponentApiModel[]> {
        let url_ = "/app/api/workspace/components?";
        if (componentIds !== undefined && componentIds !== null)
            componentIds && componentIds.forEach(item => { url_ += "componentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<UserWorkspaceComponentApiModel[]>(options_));
    }

    saveComponentState(model: ComponentStateSaveApiModel, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/workspace/component-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    /**
     * @return or

    or

    or

    or

    or

    or

    or

    or

    or

    or

    or

    or
     */
    componentTypes(cancelToken?: CancelToken): AxiosPromise<any> {
        let url_ = "/app/api/workspace/typings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "OPTIONS",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<any>(options_));
    }
}

export interface UserWorkspaceComponentApiModel {
    WorkspaceComponent: WorkspaceComponent;
    State?: UserWorkspaceComponentStateBase | undefined;
}

export interface WorkspaceComponent {
    Id: number;
    ComponentId?: string | undefined;
    Configuration?: ComponentConfigurationBase | undefined;
}

export interface ComponentConfigurationBase {
}

export interface UserWorkspaceComponentStateBase {
}

export interface ComponentStateSaveApiModel {
    WorkspaceComponentEntityId: number;
    ComponentId: string;
    ComponentStateJsonString: string;
}

export enum MarketFocus {
    Residential = 1,
    Commercial = 2,
}

export interface LogoConfiguration extends ComponentConfigurationBase {
    FileName?: string | undefined;
}

export interface NavConfiguration extends ComponentConfigurationBase {
    Description?: string | undefined;
    ShowServiceAgreement: boolean;
    ShowTasks: boolean;
    ShowProjects: boolean;
    ShowJobs: boolean;
    ShowInvoices: boolean;
}

export interface TasksConfiguration extends ComponentConfigurationBase {
}

export interface ServiceAgreementsConfiguration extends ComponentConfigurationBase {
}

export interface ProjectsConfiguration extends ComponentConfigurationBase {
}

export interface JobsConfiguration extends ComponentConfigurationBase {
}

export interface InvoicesConfiguration extends ComponentConfigurationBase {
}

export interface UserServiceAgreementsState extends UserWorkspaceComponentStateBase {
    Tab?: string | undefined;
    SelectedCustomerIdsWithLocationIds?: { [key: string]: number[]; } | undefined;
    VisitWindow?: string | undefined;
    SelectedBusinessUnits?: number[] | undefined;
    SelectedAccountManagers?: number[] | undefined;
    Sort?: string | undefined;
    RecurringEventsWindow?: string | undefined;
    RecurringEventsSort?: string | undefined;
}

export interface UserJobsState extends UserWorkspaceComponentStateBase {
    SelectedBusinessUnits?: number[] | undefined;
    UnassignedJobsTimeRange?: string | undefined;
    CustomTabs?: CustomTab[] | undefined;
}

export interface CustomTab {
    Title: string;
    TagIds: number[];
    ShowFinishedJobs?: boolean | undefined;
    SelectedBusinessUnits?: number[] | undefined;
    DateRange?: string | undefined;
    Priorities?: string[] | undefined;
    Types?: number[] | undefined;
    JobStatuses?: number[] | undefined;
    Customers?: number[] | undefined;
    Locations?: number[] | undefined;
}

export interface UserTasksState extends UserWorkspaceComponentStateBase {
    SelectedTab?: string | undefined;
}

export interface UserProjectsState extends UserWorkspaceComponentStateBase {
    SelectedCustomerIdsWithLocationIds?: { [key: string]: number[]; } | undefined;
    SelectedBusinessUnits?: number[] | undefined;
    SelectedProjectManagers?: number[] | undefined;
    SelectedStatuses?: string[] | undefined;
    Sort?: string | undefined;
}

export interface UserInvoicesState extends UserWorkspaceComponentStateBase {
    SelectedBusinessUnits?: number[] | undefined;
}
